/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/**
 * ==============================================================================
 * WYSE BOOST IMAGE OPTIMIZER
 * ==============================================================================
 * PURPOSE:
 * Patches Boost AI Search & Discovery product images on collection/search pages
 * with proper `sizes`, `fetchpriority`, and `loading` attributes. Boost bypasses
 * theme Liquid image optimization, so images render without `sizes` — causing the
 * browser to default to 100vw and download images 2-4x larger than needed.
 *
 * KEY FEATURES:
 * 1. Adds `sizes` attribute to all Boost product images (main + hover/second)
 * 2. Sets `fetchpriority="high"` on the first row of main images (above-fold LCP)
 * 3. Forces hover/second images to `loading="lazy"` (Boost incorrectly sets eager)
 * 4. Idempotent via `data-img-optimized` marker — safe across re-renders
 *
 * TRIGGER STRATEGY (mirrors boost-swatch-fetcher.js):
 * - `boost-pfs-filter-after-render` event (filter/sort/render)
 * - MutationObserver on `.boost-sd__product-list` (infinite scroll)
 * - Initial run on page load with short delay (SSR hydration)
 */

(function () {
  if (window.wyseBoostImageOptLoaded) return;
  window.wyseBoostImageOptLoaded = true;

  const SIZES = '(min-width: 48rem) 25vw, 50vw';
  const ABOVE_FOLD_COUNT = 4;
  const DEBOUNCE_DELAY = 150;
  let debounceTimer;

  const optimizeImages = () => {
    const mainImgs = document.querySelectorAll(
      '.boost-sd__product-image-img--main:not([data-img-optimized])'
    );
    const secondImgs = document.querySelectorAll(
      '.boost-sd__product-image-img--second:not([data-img-optimized])'
    );

    if (mainImgs.length === 0 && secondImgs.length === 0) return;

    // Count previously optimized main images to track grid position across
    // multiple runs (e.g. infinite scroll appending new products)
    const alreadyOptimized = document.querySelectorAll(
      '.boost-sd__product-image-img--main[data-img-optimized]'
    ).length;

    mainImgs.forEach((img, i) => {
      const gridPosition = alreadyOptimized + i;
      img.setAttribute('sizes', SIZES);
      if (gridPosition < ABOVE_FOLD_COUNT) {
        img.setAttribute('fetchpriority', 'high');
      }
      img.setAttribute('data-img-optimized', '');
    });

    secondImgs.forEach((img) => {
      img.setAttribute('sizes', SIZES);
      img.setAttribute('loading', 'lazy');
      img.setAttribute('data-img-optimized', '');
    });
  };

  const runOptimizer = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(optimizeImages, DEBOUNCE_DELAY);
  };

  // Primary trigger: Boost filter/render event
  document.addEventListener('boost-pfs-filter-after-render', runOptimizer);

  // Fallback: MutationObserver for infinite scroll / dynamic renders
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length > 0) {
        runOptimizer();
        return;
      }
    }
  });

  const targets = document.querySelectorAll('.boost-sd__product-list');
  if (targets.length > 0) {
    targets.forEach((t) => observer.observe(t, { childList: true, subtree: true }));
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initial run (SSR hydration)
  setTimeout(runOptimizer, 100);
})();
